import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";


import { DashboardRoutingModule } from "./dashboard-routing.module";
import { SalesModule } from "../sales/sales.module";
import { CompaniesModule } from '../companies/companies.module';
import { NumbersModule } from '../numbers/numbers.module';
import { EquipmentModule } from '../equipment/equipment.module';
import { InternalFacilitiesModule } from '../internal-facilities/internal-facilities.module';
import { DashboardContainerComponent } from "./containers/dashboard-container.component";
import { DashboardComponent, ToastsComponent } from "./components/";
import { KpiModule } from "../kpi/kpi.module";
import { ReviewsModule } from "../reviews/reviews.module";
import { IntegrationsModule } from "../integrations/integrations.module";

@NgModule({
  declarations: [
    DashboardContainerComponent,
    DashboardComponent,
    ToastsComponent
  ],
  imports: [
    DashboardRoutingModule,
    NgbModule,
    CommonModule,
    SalesModule,
    CompaniesModule,
    NumbersModule,
    EquipmentModule,
    InternalFacilitiesModule,
    KpiModule,
    ReviewsModule,
    IntegrationsModule,
    TranslateModule.forChild()
  ]
})
export class DashboardModule { }
